import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import fetchAPI from 'utils/http/fetchAPI';
import { EXPERIMENTS_UPDATED, EXPERIMENTS_SAVING, EXPERIMENTS_ERROR } from 'redux/actionTypes/experiments';
import pushNotificationMessage from 'utils/pushNotificationMessage';
import handleError from 'utils/http/handleError';
var reorderSamples = function reorderSamples(experimentId, oldIndex, newIndex) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var _body, _newSampleOrder, _errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                type: EXPERIMENTS_SAVING
              });
              _context.prev = 1;
              _body = {
                oldPosition: oldIndex,
                newPosition: newIndex
              };
              _context.next = 5;
              return fetchAPI("/v2/experiments/".concat(experimentId, "/samples/position"), {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(_body)
              });
            case 5:
              _newSampleOrder = _context.sent;
              dispatch({
                type: EXPERIMENTS_UPDATED,
                payload: {
                  experimentId: experimentId,
                  experiment: {
                    sampleIds: _newSampleOrder
                  }
                }
              });
              _context.next = 15;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              _errorMessage = handleError(_context.t0);
              dispatch({
                type: EXPERIMENTS_ERROR,
                payload: {
                  error: _errorMessage
                }
              });
              pushNotificationMessage('error', _errorMessage);

              // Throwing so we can stop ui updates
              throw _context.t0;
            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default reorderSamples;